module.exports = __webpack_public_path__ + "img/812828_521818_C94141_AB3737-256px.c595787f.png";